var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegraibeyaz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1678.02 284.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 40.62 0 81.23 0 121.84 0 162.45 0 203.06 0 243.68 0 284.29 40.61 284.29 40.61 243.68 40.61 203.06 40.61 162.45 40.61 121.84 40.61 81.23 40.61 40.62 40.61 0 0 0 0 40.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.29,0v284.29h-40.61v-97.57c0-4.25-1.68-8.32-4.67-11.33L121.84,57.44v226.86h-40.61V0h40.61l121.84,121.84V0h40.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.51,0h-35.46c-2.84,0-5.15,2.31-5.15,5.15v35.46h81.22V0h-40.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.95,0v40.61h-72.67c-4.72,0-8.54,3.83-8.54,8.54v235.14h-40.61V40.61h37.58c1.67,0,3.03-1.36,3.03-3.03V0h81.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "609.18 158.85 646.19 121.84 771.63 121.84 771.63 162.45 609.18 162.45 609.18 243.68 771.63 243.68 771.63 284.29 609.18 284.29 568.56 243.68 568.56 40.61 609.18 0 771.63 0 771.63 40.61 609.18 40.61 609.18 158.85"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M852.85,49.15v185.99c0,4.72,3.81,8.54,8.54,8.54h104.75c4.72,0,8.56-3.81,8.56-8.54v-64.15c0-4.7-3.83-8.54-8.56-8.54h-32.06v-40.61h40.61l40.61,40.61v81.23h-32.08c-4.72,0-8.54,3.83-8.54,8.54v32.08h-121.84v-32.08c0-4.7-3.83-8.54-8.56-8.54h-32.06V40.61h32.06c4.72,0,8.56-3.81,8.56-8.54V0h162.45v40.61h-153.92c-4.72,0-8.54,3.83-8.54,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1470.57,40.61c-4.7,0-8.54-3.81-8.54-8.54V0h-81.23l-40.61,40.61-40.59,40.61v203.07h40.59v-81.23h113.3c4.71,0,8.54,3.82,8.54,8.54v72.69h40.61V40.61h-32.08ZM1462.03,153.92c0,4.71-3.82,8.54-8.54,8.54h-75.71l-33.64,33.64c-1.46,1.46-3.95.43-3.95-1.64v-85.91l33.97-33.95,33.97-33.97h45.36c4.71,0,8.54,3.82,8.54,8.54v104.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1226.91,121.84h32.08V40.61h-32.08c-4.7,0-8.54-3.81-8.54-8.54V0h-162.45v284.29h40.61v-121.84h60.92l40.61,40.61,20.31,20.31v60.92h40.61v-81.23l-40.61-40.61v.46l-.23-.46h.23v-32.08c0-4.7,3.81-8.54,8.54-8.54ZM1209.84,121.84h-75.59l-33.76,33.76c-1.46,1.46-3.95.43-3.95-1.64V49.15c0-4.7,3.81-8.54,8.54-8.54h104.77c4.71,0,8.54,3.82,8.54,8.54v64.15c0,4.71-3.82,8.54-8.54,8.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1462.03,
    y: 243.68,
    width: 40.61,
    height: 40.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1520.49,243.68h26.75c7.65,0,13.86,6.21,13.86,13.86v26.75h-40.61v-40.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1619.56,0v40.61h-32.71c-4.36,0-7.9-3.54-7.9-7.9V0h40.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1578.95,81.23h30.48c5.6,0,10.13,4.54,10.13,10.13v192.93h-40.61V81.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1637.41,243.68h26.75c7.65,0,13.86,6.21,13.86,13.86v26.75h-40.61v-40.61h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegraibeyaz);
export default __webpack_public_path__ + "static/media/integrai beyaz.edb111582afaf1e1345fdf7728297416.svg";
export { ForwardRef as ReactComponent };